import { AxiosInstance } from "axios";
import { getBoardApiUrl } from "helpers";
import { AddAgendaItemModel } from "models/AddAgendaItemModel";
import { AgendaItemDetailModel } from "models/AgendaItemDetailModel";
import { AgendaItemModel } from "models/AgendaItemModel";
import { PatchAgendaItemModel } from "models/PatchAgendaItemModel";
import { SiveActionResult } from "models/SiveActionResult";

export class AgendaItemsApi {
  constructor(private axios: AxiosInstance) {}

  async getItems() {
    const url = getBoardApiUrl(`agendaItems`);
    const response = await this.axios.get<AgendaItemDetailModel[]>(url);
    return response.data;
  }

  async getItem(agendaItemId: number) {
    if (!agendaItemId) throw new Error("agendaItemId is required");
    const url = getBoardApiUrl(`agendaItems/${agendaItemId}`);
    const response = await this.axios.get<AgendaItemModel>(url);
    return response.data;
  }

  async addToMeeting(model: AddAgendaItemModel) {
    const { meetingId } = model;
    if (!meetingId) throw new Error("MeetingId is required");
    const url = getBoardApiUrl(`agendaItems/meeting/${meetingId}`);
    const response = await this.axios.post<SiveActionResult>(url, model);
    return response.data;
  }

  async delete(agendaItemId: number) {
    if (!agendaItemId) throw new Error("agendaItemId is required");
    const url = getBoardApiUrl(`agendaItems/${agendaItemId}`);
    const response = await this.axios.delete<SiveActionResult>(url);
    return response.data;
  }

  async update(patch: PatchAgendaItemModel) {
    const { id: agendaItemId } = patch;
    if (!agendaItemId) throw new Error("Id is required");
    const url = getBoardApiUrl(`agendaItems/${agendaItemId}`);
    const response = await this.axios.patch<SiveActionResult>(url, patch);
    return response.data;
  }

  async indent(agendaItemId: number) {
    if (!agendaItemId) throw new Error("agendaItemId is required");
    const url = getBoardApiUrl(`agendaItems/${agendaItemId}/indent`);
    const response = await this.axios.post(url);
    return response.data;
  }

  async outdent(agendaItemId: number) {
    if (!agendaItemId) throw new Error("agendaItemId is required");
    const url = getBoardApiUrl(`agendaItems/${agendaItemId}/outdent`);
    const response = await this.axios.post(url);
    return response.data;
  }

  async copyTo(agendaItemId: number, otherMeetingId: number) {
    if (!agendaItemId) throw new Error("agendaItemId is required");
    if (otherMeetingId <= 0) throw new Error("otherMeetingId is required");
    const url = getBoardApiUrl(`agendaItems/${agendaItemId}/copyTo/${otherMeetingId}`);
    const response = await this.axios.post(url);
    return response.data;
  }

  async moveTo(agendaItemId: number, otherMeetingId: number) {
    if (!agendaItemId) throw new Error("agendaItemId is required");
    if (otherMeetingId <= 0) throw new Error("otherMeetingId is required");
    const url = getBoardApiUrl(`agendaItems/${agendaItemId}/moveTo/${otherMeetingId}`);
    const response = await this.axios.post(url);
    return response.data;
  }

  async reorder(agendaItemId: number, previousItemId: number) {
    if (agendaItemId <= 0) throw new Error("agendaItemId is required");
    if (previousItemId <= 0) throw new Error("previousItemId is required");

    const url = getBoardApiUrl(`agendaItems/${agendaItemId}/reorder/${previousItemId}`);
    const response = await this.axios.post(url);
    return response.data;
  }
}
